import React from "react";
import AlleywayGCard from "./card/AlleywayG-card";
import { useNavigate } from "react-router-dom";
import { MARKET_PLACE } from "src/constants/routes";
import LeaderBoardCardSkeleton from "components/Loader/Skeleton/LeaderBoardCardSkeleton";

export default function TopGangster({
  GangsterActiveFilter,
  setGangsterActiveFilter,
  gangstersData,
  isLoading,
  filterData,
}) {
  const navigate = useNavigate();
  const clickHandler = (e) => {
    navigate(`${MARKET_PLACE.INDEX}?type=Gangster&sort_by=popular`);
    window.location.reload();
  };
  return (
    <div className="alley-topGangster">
      <div className="tg-header">
        <div className="tg-top">
          <h3>Top Gangsters</h3>
          <div className="filter-container">
            {/* <div className="filter-text">Filter</div> */}
            <div
              className="al-filters dropdown-toggle"
              id="dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {
                <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.92 8.17969H11.69H6.07999C5.11999 8.17969 4.63999 9.33969 5.31999 10.0197L10.5 15.1997C11.33 16.0297 12.68 16.0297 13.51 15.1997L15.48 13.2297L18.69 10.0197C19.36 9.33969 18.88 8.17969 17.92 8.17969Z" fill="#DADADA" />
                </svg>
              }
              <div className="al-filter-selected ">
                {GangsterActiveFilter
                  ? GangsterActiveFilter.split("-").splice(1).join("-")
                  : "All"}
              </div>
              {GangsterActiveFilter ? (
                <svg
                  className="close"
                  xmlns="http://www.w3.org/2000/svg"
                  height="18px"
                  viewBox="0 0 24 24"
                  onClick={(e) => {
                    setGangsterActiveFilter(null);
                    document.getElementById("dp-m").classList.remove("show");
                    document
                      .getElementById("dropdown-toggle")
                      .classList.remove("show");
                    document
                      .getElementById("dropdown-toggle")
                      .setAttribute("aria-expanded", "false");
                  }}
                  width="18px"
                  fill="#000000"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              ) : null}
            </div>

            <ul class="dropdown-menu p-3" id="dp-m" aria-labelledby="sortby">
              <p>Class</p>
              {filterData?.class_types?.Gangster.map((data, index) => (
                <li
                  onClick={(e) => {
                    setGangsterActiveFilter(`Type-${data}`);
                  }}
                  key={index}
                  className="mb-1"
                >
                  <button class="dropdown-item"> {data} </button>
                </li>
              ))}
              <hr style={{ margin: "5px 0" }} />
              <p>Level</p>
              {filterData?.level?.Gangster.map((data, index) => (
                <li
                  onClick={(e) => {
                    setGangsterActiveFilter(`Level-${data}`);
                  }}
                  key={index}
                  className="mb-1"
                >
                  <button class="dropdown-item"> {data} </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {isLoading
          ? [...Array(10)].map(() => <LeaderBoardCardSkeleton />)
          : null}
        {gangstersData?.map((data, index) => (
          <AlleywayGCard
            key={index}
            token_uri={data.token_uri}
            token_id={data.token_id}
            class_type={data.class_type}
            token_name={data.token_name}
            total_stats={data.total_stats}
            skills={data.skills}
            salePrice={-1}
          />
        ))}
      </div>
      <div className="view-all-cta" onClick={clickHandler}>
        {" "}
        View All
      </div>
    </div>
  );
}
